import { LogoHeader1, MenuIcon, UserOutline } from "../assets/img";
import { Link, useLocation } from "react-router-dom";
import { Link as ScrollLink } from "react-scroll";
import Container from "./Container";
import { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { useWallet } from "../web3/useWallet";
import { toast } from "react-toastify";

const Navbar = () => {
  let location = useLocation();
  const history = useHistory();
  const dropdownRef = useRef(null);
  const wallet = useWallet();

  const currentPathName = location?.pathname;
  let [isNavigationOpen, setNavigationOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const handleConnectClick = () => {
    if (!wallet?.ethereumPresent) {
      toast.error("MetaMask is not installed. Please install it to connect your wallet.");
      return;
    }
    wallet?.connect?.();
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  return (
    <>
      <nav className="bg-secondary sticky top-0 md:relative z-40">
        <Container className="h-[90px] py-5">
          <div className="flex items-center">
            {/* Logo + Brand */}
            <Link to="/" className="flex items-center w-auto">
              <img
                src={LogoHeader1}
                alt="Sportfolio Logo"
                className="h-auto max-h-10 w-auto"
              />
              <span className="hidden md:block ml-2 font-inter font-semibold tracking-wide text-white">
                Sportfolio
              </span>
            </Link>

            {/* Divider */}
            <div className="hidden md:inline-block mx-6 ml-14 h-12 border-l border-white/10"></div>

            {/* Navigation */}
            <div className="w-full">
              {/* Desktop Navigation */}
              <div className="hidden md:flex items-center justify-between w-full">
                <div className="flex items-center space-x-2">
                  {[
                    { to: "/", label: "Home" },
                    { to: "/account", label: "Account" },
                    { to: "/product-demo", label: "Demo" },
                  ].map(({ to, label }) => {
                    const isActive = currentPathName === to;
                    return (
                      <Link
                        key={to}
                        to={to}
                        className={`relative px-5 transition-colors duration-200 text-white font-inter ${
                          isActive ? "font-semibold" : "font-light"
                        }`}
                      >
                        {label}
                        {isActive && (
                          <span className="absolute -bottom-2 left-1/2 h-1 w-1 -translate-x-1/2 transform rounded-full bg-white" />
                        )}
                      </Link>
                    );
                  })}
                </div>

                <div className="relative" ref={dropdownRef}>
                  <div className="flex items-center gap-3 px-4 py-2 rounded-md shadow">
                    <div className="flex items-center gap-2 sm:gap-3">
                      <span className="text-white font-light font-poppins whitespace-nowrap">
                        Holdings :{" "}
                        <span className="font-medium">
                          {wallet?.account
                            ? wallet?.isSepolia
                              ? `${wallet?.holdingsSummary || "0"} tokens`
                              : "Wrong network"
                            : ""}
                        </span>
                      </span>
                      {!wallet?.account && (
                        <button
                          onClick={handleConnectClick}
                          className="bg-primary text-white text-xs md:text-sm font-roboto rounded px-3 py-2 shadow-md whitespace-nowrap"
                          disabled={wallet?.isConnecting}
                        >
                          {wallet?.isConnecting ? "Connecting..." : "Connect"}
                        </button>
                      )}
                    </div>
                    <div className="hidden md:inline-block mx-1 lg:mx-3 h-12 border-l border-white/10"></div>

                    {/* User Icon Button */}
                    <button
                      onClick={() => setDropdownOpen((prev) => !prev)}
                      className="bg-[#FACC15] w-[35px] h-[35px] flex items-center justify-center rounded-full"
                    >
                      <UserOutline className="text-black" />
                    </button>

                    {/* Dropdown Menu */}
                    {dropdownOpen && (
                      <div className="absolute right-0 top-full w-60 bg-gray-100 rounded-md shadow-custom4 border-secondary/20 border z-50">
                        <ul className="flex flex-col text-sm">
                          {wallet?.account && (
                            <li className="px-4 py-2 text-xs text-gray-600">
                              {wallet.account.slice(0, 6)}...
                              {wallet.account.slice(-4)}
                            </li>
                          )}
                          {wallet?.account && wallet?.isSepolia && (
                            <li className="px-4 py-2 text-xs text-gray-600">
                              USDC: {wallet?.usdcBalanceDisplay || "—"}
                            </li>
                          )}
                          {wallet?.account && wallet?.isSepolia && (
                            <li className="px-2 py-2">
                              <div className="text-xs text-gray-500 px-2 pb-1">
                                Team holdings
                              </div>
                              <div className="max-h-52 overflow-auto">
                                {wallet.teamHoldings?.map((t) => (
                                  <div
                                    key={t.tokenId}
                                    className="flex items-center gap-2 px-2 py-2 bg-white rounded mb-1 shadow-custom4"
                                  >
                                    {t.logo && (
                                      <img
                                        src={t.logo}
                                        alt=""
                                        className="w-6 h-6 rounded-full object-cover"
                                      />
                                    )}
                                    <div className="flex-1">
                                      <div className="text-xs font-semibold text-black">
                                        {t.name}
                                      </div>
                                      <div className="text-[11px] text-gray-600">
                                        {Number(t.balanceNum || 0).toLocaleString()} tokens ·{" "}
                                        {t.ownershipPct ? t.ownershipPct.toFixed(6) : "0"}%
                                      </div>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </li>
                          )}
                          <li
                            onClick={() => {
                              history.push("/settings");
                              setDropdownOpen(false);
                            }}
                            className="px-4 py-2 rounded-md text-black cursor-pointer shadow-custom4 bg-white hover:bg-gray-100"
                          >
                            Settings
                          </li>
                          {wallet?.account && (
                            <li
                              onClick={() => {
                                wallet.disconnect();
                                setDropdownOpen(false);
                              }}
                              className="px-4 py-2 rounded-md text-black cursor-pointer shadow-custom4 bg-white hover:bg-gray-100"
                            >
                              Disconnect
                            </li>
                          )}
                        </ul>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div className="flex md:hidden place-self-end">
                <button
                  className="w-[34px] h-[34px] rounded-full bg-primary flex items-center justify-center"
                  onClick={() => setNavigationOpen(true)}
                >
                  <img src={MenuIcon} alt="menu" />
                  {/* <MenuIcon /> */}
                </button>
              </div>
            </div>
          </div>
        </Container>
      </nav>

      {/* Mobile Navigation */}
      <div
        className={`fixed top-5 right-0 h-screen w-[270px] md:hidden bg-secondary z-50 font-inter p-8 pt-5 transform transition-transform duration-300 ease-in-out
          ${isNavigationOpen ? "translate-x-0" : "translate-x-full"}`}
      >
        <div className="flex items-center">
          <div className="ml-auto">
            <button
              onClick={() => setNavigationOpen(false)}
              className="w-8 h-8 rounded-md bg-white flex items-center justify-center"
            >
              <i className="fa fa-times"></i>
            </button>
          </div>
        </div>

        {[
          { to: "/", label: "Home" },
          { to: "/account", label: "Account" },
          { to: "/product-demo", label: "Product Demo" },
          { to: "/settings", label: "Settings" },
          // { to: "#", label: "Join Waitlist", scroll: true },
          // { to: "#", label: "How it works" },
          // { to: "#", label: "Valuation" },
        ].map(({ to, label, scroll }) => {
          const isActive = currentPathName === to;

          const classes = `relative block text-white text-lg font-semibold py-3 border-b border-gray-600/40`;

          if (scroll) {
            return (
              <ScrollLink
                key={to}
                to={to}
                smooth
                onClick={() => setNavigationOpen(false)}
                className={classes}
              >
                {isActive && (
                  <span className="absolute left-0 top-1/2 -translate-y-1/2 h-2 w-2 rounded-full bg-white" />
                )}
                <span className="ml-4">{label}</span>
              </ScrollLink>
            );
          }

          return (
            <Link
              key={to}
              to={to}
              onClick={() => setNavigationOpen(false)}
              className={classes}
            >
              {isActive && (
                <span className="absolute left-0 top-1/2 -translate-y-1/2 h-2 w-2 rounded-full bg-white" />
              )}
              <span className="ml-4">{label}</span>
            </Link>
          );
        })}
      </div>
    </>
  );
};

export default Navbar;
